// The Android Stream app (frontend/android, docs/features/android-stream-app.md).
// While its Google Play listing is in review, the invite page sends Android phones
// to the internal testing opt-in; the homepage live hero offers the app only with
// the PostHog flag `android-stream-app` (useAndroidAppEnabled).

/** Google Play package of the production app; `assetLinks.js` verifies the same one. */
export const ANDROID_APP_PACKAGE = 'live.streambridge.stream'
export const ANDROID_APP_FLAG = 'android-stream-app'

/**
 * Google Play's internal testing opt-in (the "StreamBridge team" tester list). Set to null
 * once the listing is public, so invites link the listing with the invite as install referrer.
 */
export const ANDROID_INTERNAL_TEST_URL: string | null = 'https://play.google.com/apps/internaltest/4701033601832456025'

export type InvitePlatform = 'ios' | 'android' | 'unknown'

/** The phone a camera invite was opened on. iPadOS asks for desktop sites as a Mac; its touch screen gives it away. */
export function invitePlatform(userAgent: string, maxTouchPoints = 0): InvitePlatform {
  if (/iPhone|iPad|iPod/i.test(userAgent)) return 'ios'
  if (/Macintosh/i.test(userAgent) && maxTouchPoints > 1) return 'ios'
  if (/Android/i.test(userAgent)) return 'android'
  return 'unknown'
}

/**
 * The Google Play listing with the camera invite as its install referrer. On first
 * launch the app reads `invite=<invite URL>` through the Play Install Referrer API
 * and opens that camera.
 */
export function googlePlayUrl(inviteUrl: string): string {
  const referrer = `invite=${encodeURIComponent(inviteUrl)}`
  return `https://play.google.com/store/apps/details?id=${ANDROID_APP_PACKAGE}&referrer=${encodeURIComponent(referrer)}`
}

/**
 * Where the invite page's Google Play badge goes. The internal testing opt-in carries no
 * referrer, so a tester opens the invite again after installing (Open Stream app, or the
 * link itself once App Links verify).
 */
export function androidInstallUrl(inviteUrl: string, internalTestUrl = ANDROID_INTERNAL_TEST_URL): string {
  return internalTestUrl ?? googlePlayUrl(inviteUrl)
}

/** Which stores to offer: the phone's own, or both when the platform is unknown. */
export function appStores(platform: InvitePlatform) {
  return { appStore: platform !== 'android', googlePlay: platform !== 'ios' }
}
